import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1025af66"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "scan-qrcode-wrap"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scan-text" }, "请使用手机微信扫描二维码访问", -1))
const _hoisted_3 = { class: "scan-qrcode" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "xag-container map-div" }
const _hoisted_6 = {
  ref: "mapbox",
  class: "map-box"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "site-icon" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_NetworkPoints = _resolveComponent("NetworkPoints")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, {
      title: "服务网点",
      isReturnLeftEvent: "",
      onLeftClick: _ctx.onLeftClick,
      leftArrowShow: !_ctx.isTableDevice
    }, null, 8, ["onLeftClick", "leftArrowShow"]),
    (_ctx.isSrc4Device)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "qrcode-img",
              src: _ctx.qrcodeUrl,
              alt: "服务网点"
            }, null, 8, _hoisted_4)
          ])
        ]))
      : (_ctx.locationInfo?.lat && _ctx.locationInfo?.lng)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, null, 512),
              (_ctx.map)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "site-box xag-flex-center",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.relocationSite(true)))
                  }, _hoisted_8))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.isNoSearching]
            ]),
            _withDirectives(_createElementVNode("div", {
              class: "xag-page__footer",
              style: _normalizeStyle({ height: `calc(${_ctx.pHeight} - 12px)` })
            }, null, 4), [
              [_vShow, _ctx.isNoSearching]
            ]),
            (_ctx.isNoSearching)
              ? (_openBlock(), _createBlock(_component_van_popup, {
                  key: 0,
                  class: "network-point-popup",
                  onTouchend: _ctx.touchEnd,
                  onTouchstart: _ctx.touchStart,
                  show: _ctx.show,
                  "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.show) = $event)),
                  "before-close": () => false,
                  closeable: _ctx.popupCloseabled,
                  round: "",
                  position: "bottom",
                  onClickCloseIcon: _ctx.onLeftClick,
                  "safe-area-inset-bottom": "",
                  overlay: false,
                  style: _normalizeStyle({ height: _ctx.pHeight })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view, {
                      onSearchFocus: _ctx.onSearchFocus,
                      onSetCenter: _ctx.onSetCenter
                    }, null, 8, ["onSearchFocus", "onSetCenter"])
                  ]),
                  _: 1
                }, 8, ["onTouchend", "onTouchstart", "show", "before-close", "closeable", "onClickCloseIcon", "style"]))
              : _createCommentVNode("", true),
            (!_ctx.isNoSearching)
              ? (_openBlock(), _createBlock(_component_NetworkPoints, {
                  key: 1,
                  onSearchBlur: _ctx.onSearchBlur,
                  autoFocus: ""
                }, null, 8, ["onSearchBlur"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
  ], 64))
}